import { Instance } from 'mobx-state-tree';
import { RouteDtoEdgeModelBase } from './RouteDtoEdgeModel.base';

/* The TypeScript type of an instance of RouteDtoEdgeModel */
export interface RouteDtoEdgeModelType extends Instance<typeof RouteDtoEdgeModel.Type> {}

/* A graphql query fragment builders for RouteDtoEdgeModel */
export { selectFromRouteDtoEdge, routeDtoEdgeModelPrimitives, RouteDtoEdgeModelSelector } from './RouteDtoEdgeModel.base';

/**
 * RouteDtoEdgeModel
 */
export const RouteDtoEdgeModel = RouteDtoEdgeModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
